import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const notificacionImporterSelectors = importerSelectors(
  'notificacion.importer',
);

export default notificacionImporterSelectors;
